import React from "react";
import Link from "gatsby-link";

function Buyvariants(props){

  let v = props.on;
  let obj1 = null;
  let objo = null;

  switch (v){
    case 'on0':

    obj1 = props.post.on0;
    objo = props.post.on0_options.split(',');
    break;
    case 'on1':
    obj1 = props.post.on1;
    objo = props.post.on1_options.split(',');
    break;
    case 'on2':
    obj1 = props.post.on2;
    objo = props.post.on2_options.split(',');
    break;
  }


  if(props.post.option1 != '')
  {
    return (<div><input type="hidden" name={v} value={obj1}/>{obj1} <br/><select name={props.sn}>
      {objo.map(function(i){
        return <option value={i}>{i}</option>
      })}
    </select><br/></div>);
  }
  else
  {
    return '';
  }
}

function Buyoptions(props){

  let v = props.on;
  let obj1 = null;
  let objo = null;

  switch (v){
    case 'option1':

    obj1 = props.post.option1;
    objo = props.post.option1_options;
    break;
    case 'option2':

    obj1 = props.post.option2;
    objo = props.post.option2_options;
    break;
    case 'option3':

    obj1 = props.post.option3;
    objo = props.post.option3_options;
    break;
  }


  if(props.post.option1 != '')
  {
    return (<div>{obj1} <br/><select name={props.sn}>
      {objo.map(function(i){
        return <option value={i}>{i}</option>
      })}
    </select><br/></div>);
  }
  else
  {
    return '';
  }
}

export default class Parent extends React.Component {
  render(){
    var post = this.props.post;

    if(this.props.post.sub_items.length > 0 && this.props.post.sub_items[0]['option1_value'] != '')
    {

      return (<form action={'https://www.e-junkie.com/ecom/gb.php?c=cart&cl=' + post.ej_shop_id + '&i=' + post.number + '&ejc=2'} method="POST" target="ej_ejc" acceptCharset="UTF-8">
        <Buyoptions post={post} on="option1" sn="o1" />
        <Buyvariants post={post} on="on0" sn="os0" hv="os0" />
        <Buyvariants post={post} on="on1" sn="os1" hv="os1" />
        <input type='hidden' name='c' value='cart'/><input type='hidden' name='cl' value={post.ej_shop_id}/><input type='hidden' name='i' value={post.number}/><input type='hidden' name='ejc' value='2'/><input type="image" src="https://www.e-junkie.com/ej/ej_add_to_cart.gif" alt="Add to Cart" className="ec_ejc_thkbx"/>
        </form>);
    }
    else
    {
      return (<a href={'https://www.e-junkie.com/ecom/gb.php?c=cart&amp;i=' + post.number + '&amp;cl=' + post.ej_shop_id + '&amp;ejc=2'} target="ej_ejc" className="ec_ejc_thkbx"><input type="image" src="https://www.e-junkie.com/ej/ej_add_to_cart.gif" alt="Add to Cart" className="ec_ejc_thkbx"/></a>);
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Buynow.js